import BookingFiltersComponent from "../BookingFiltersComponent";
import SlotsHeaderComponent from "../Header";

const SlotsHeaderContainer = () => {
  return (
    <div className=" rounded-md">
      <div className=" w-full  items-center">
        <BookingFiltersComponent cacheFilters={false} />
      </div>
      <SlotsHeaderComponent />
    </div>
  );
};

export default SlotsHeaderContainer;
